import React from "react";
import {
  SectionSeven,
  SectionSevenInner,
  SectionSevenGrid,
  SectionSevenCopy,
  SectionSevenTitle,
  SectionSevenLead,
  SectionSevenBody,
  SectionSevenTech,
  SectionSevenMobileTech,
  SectionSevenMobileBody,
  SectionSevenMobileButton,
  SectionButton,
  SectionSevenCta,
  SectionSevenVisual,
  SectionSevenTrati,
  SectionSevenLogo,
} from "./styles";

export default function SectionSevenComponent({ onOpenPlans }) {
  return (
    <SectionSeven>
      <SectionSevenInner>
        <SectionSevenGrid>
          <SectionSevenCopy>
            <SectionSevenTitle>A TRATI</SectionSevenTitle>

            <SectionSevenLead>
              ELA É SUA <strong>ASSISTENTE VIRTUAL.</strong>
              <br />
              APOIA DECISÕES E CONDUTAS TERAPEUTICAS
            </SectionSevenLead>

            <SectionSevenBody>
              Nossa IA escuta suas consultas e gera relatórios personalizados
              automaticamente, economizando tempo e AUXILIANDO na precisão
              diagnóstica.
            </SectionSevenBody>

            <SectionSevenTech>
              TECNOLOGIA INTELIGENTE QUE TRABALHA COM VOCÊ
            </SectionSevenTech>

            <SectionButton>
              <SectionSevenCta type="button" onClick={onOpenPlans}>
                CLIQUE AQUI E ESCOLHA SEU MELHOR PLANO
              </SectionSevenCta>
            </SectionButton>
          </SectionSevenCopy>

          <SectionSevenVisual>
            <SectionSevenMobileTech>
              TECNOLOGIA
              <br />
              INTELIGENTE
              <br />
              QUE TRABALHA
              <br />
              COM VOCÊ
            </SectionSevenMobileTech>
            <SectionSevenLogo
              src="/novas-imagens/section-seven/logo.png"
              alt="Logo Trataz"
            />
            <SectionSevenTrati
              src="/novas-imagens/section-seven/trati.png"
              alt="Trati"
            />
          </SectionSevenVisual>

          <SectionSevenMobileBody>
            Nossa IA escuta suas consultas e gera relatórios personalizados
            automaticamente, economizando tempo e AUXILIANDO na precisão
            diagnóstica.
          </SectionSevenMobileBody>

          <SectionSevenMobileButton>
            <SectionSevenCta type="button" onClick={onOpenPlans}>
              CLIQUE AQUI E ESCOLHA SEU MELHOR PLANO
            </SectionSevenCta>
          </SectionSevenMobileButton>
        </SectionSevenGrid>
      </SectionSevenInner>
    </SectionSeven>
  );
}
